exports.computeSelectionYpos = boundingBox => boundingBox.get('y');
